import { render } from "./OtherGlasses.vue?vue&type=template&id=408e09ba&scoped=true"
import script from "./OtherGlasses.vue?vue&type=script&lang=js"
export * from "./OtherGlasses.vue?vue&type=script&lang=js"

import "./OtherGlasses.vue?vue&type=style&index=0&id=408e09ba&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408e09ba"]])

export default __exports__